import { inject, Injectable } from '@angular/core';
import { Auth, ConfirmationResult, RecaptchaVerifier, User, signInWithPhoneNumber, user, updateProfile, signOut, signInWithCustomToken } from '@angular/fire/auth';
import { Functions, httpsCallable } from '@angular/fire/functions';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAuthService {
    private auth: Auth = inject(Auth);
    private firebaseFunctions: Functions = inject(Functions);

    // Angular Auth Observables
    user$ = user(this.auth);
    // authState$ = authState(this.auth);
    // idToken$ = idToken(this.auth);

    confirmationResult: ConfirmationResult | undefined;
    recaptchaVerifier: RecaptchaVerifier | undefined;
    
    constructor() {}

    setRecaptchaVerifier(signInButtonId: string) {
        console.log('setRecaptchaVerifier', signInButtonId);
        if(this.recaptchaVerifier) return;
        try {
            // Check if the element exists first
            const element = document.getElementById(signInButtonId);
            if (!element) {
                console.warn(`Element with id '${signInButtonId}' not found. reCAPTCHA setup skipped.`);
                return;
            }

            this.recaptchaVerifier = new RecaptchaVerifier(this.auth, signInButtonId, {
                size: 'invisible',
                callback: () => {
                    // reCAPTCHA solved, allow signInWithPhoneNumber.
                    // callback();
                    console.log('callback');
                    const recaptchaElement = document.getElementById('recaptcha-container');
                    if(recaptchaElement) {
                        recaptchaElement.style.display = "none";
                    }
                }
            });
            console.log('recaptchaVerifier', this.recaptchaVerifier);
        } catch(error) {
            console.log('reCAPTCHA setup failed:', error);
            // Don't throw error, just log it and continue
        }
    }

    async loginWithPhoneNumber(phoneNumber: string) {
        try {
            if (!this.recaptchaVerifier) {
                console.warn('reCAPTCHA verifier not available. Phone login may not work properly.');
                // You might want to throw an error here or handle it differently
                throw new Error('reCAPTCHA not configured');
            }
            this.confirmationResult = await signInWithPhoneNumber(this.auth, phoneNumber, this.recaptchaVerifier as RecaptchaVerifier);
        } catch(error) {
            console.log('Phone login failed:', error);
            throw new Error('Login Failed');
        }
    }

    setConfirmationResultFromNativeLayerLogin(confirmationResult: ConfirmationResult) {
        this.confirmationResult = confirmationResult;
    }

    async signInWithToken(uid: string) {
        try {
            const createLoginCustomTokenFn = httpsCallable(this.firebaseFunctions, 'createLoginCustomToken');
            const response = await createLoginCustomTokenFn({idToken: uid});
            const {token} = response.data as {token: string};
            const userCredentials = await signInWithCustomToken(this.auth, token);
            return userCredentials;
        } catch(error) {
            console.log(error);
            throw new Error('OTP Verification Failed');
        }
    }

    async verifyOTP(otp: string) {
        try {
            const userCredentials = await this.confirmationResult?.confirm(otp);
            return userCredentials;
        } catch(error) {
            console.log(error);
            throw new Error('OTP Verification Failed');
        }
    }

    async updateUserProfile(user: User, {displayName, photoURL}: {displayName: string | null, photoURL: string | null}) {
        displayName = displayName || user.displayName || null;
        photoURL = photoURL || user.photoURL ||  null;
        try {
            await updateProfile(user, {displayName, photoURL});
        } catch(error) {
            console.log(error);
            throw new Error('Update User Profile Failed');
        }
    }

    async logout() {
        try {
            await signOut(this.auth);
        } catch(error) {
            console.log(error);
            throw new Error('Logout Failed');
        }
    }
}